import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './components/theme/ThemeProvider';
import Layouts from './components/layouts';
import withClearCache from './ClearCache';
import RTL from './components/theme/Rtl';
import config from './util/config';

const ClearCacheComponent = withClearCache(PidoOperatorWebApp);

function App(props) {
  return <ClearCacheComponent {...props} />;
}

function PidoOperatorWebApp(props) {
  return (
    <div dir="rtl">
      <ThemeProvider>
        <RTL>
          <CssBaseline />
          <BrowserRouter basename={config.basename}>
            <Layouts />
          </BrowserRouter>
        </RTL>
      </ThemeProvider>
    </div>
  );
}

export default App;
